import {httpGet} from "./http";

export const getCustomerAccount = () => httpGet('token/customer-account');